









import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Advice, {IAdvice} from '@/models/Advice'
import Post, {IPost} from '@/models/Post'
import {apiV1AdminAdvicePath} from '@/rails/routes'
import AddinForm from '@/components/admin/advices/AddinForm.vue'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    AddinForm,
    PostForm
  }
})
export default class AdviceEdit extends PostEdit {

  mounted(): Promise<void> {
    this.targetPath = apiV1AdminAdvicePath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Advice(data as IAdvice)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '沖縄移住相談室一覧',
        to: '/admin/advices',
        exact: true
      },
      {
        text: '沖縄移住相談室編集'
      }
    ]
  }
}
